<template>
  <div class="d-flex flex-column min-vh-100">
    <Navigation></Navigation>

    <div class="d-flex flex-grow-1 justify-content-center">
      <div
        v-if="loading"
        style="
          font-weight: 500;
          font-size: 1.3rem;
          margin-top: 30%;
          align-self: center;
        "
      >
        <div class="card">
          <div class="card-body">
            <div class="mr-2 spinner-border text-primary" role="status"></div>
            Loading...
          </div>
        </div>
      </div>

      <router-view v-else class="py-4" v-bind="{ apps, fetchApps }" />
    </div>

    <Footer class="mt-auto"></Footer>
  </div>
</template>

<script>
import Footer from "./components/Footer.vue"
import Navigation from "./components/Navigation.vue"

export default {
  name: "App",
  components: {
    Footer,
    Navigation,
  },
  data() {
    return {
      apps: [],
      loading: true,
    }
  },
  async beforeMount() {
    await this.$auth.login()
    this.fetchApps()
  },
  methods: {
    async fetchApps() {
      const [_error, { data }] = await this.$api.get("/apps")
      if (data) {
        this.apps = data
        this.loading = false
      }
    },
  },
}
</script>
